'use strict';

angular.module('app')
    .controller('SweepCtrl', function ($scope, $routeParams, Auth, GTM) {

        var vm = this;

        vm.auth = Auth;

        vm.createAccount = function (credentials) {
            if ($scope.registrationForm.$invalid) {
                return vm.formSubmited = true;
            }

            vm.regErrors = false;

            vm.auth.registration(credentials, true).catch(function (data) {
                vm.regErrors = data;
            }).then(function () {
                vm.registration.credentials = {};
            });
        };
    });
